import { PazienCollection } from "common/collections/pazienCollection";
import { UserModel } from "common/features/user/model";

export const UsersCollection = PazienCollection.extend({
    url: "/merchant/:merchant_ref/users/",
    model: UserModel,
    inGroup(groupID) {
        return this.filter((user) => {
            if (groupID) {
                return (user.get("groups") || []).includes(groupID);
            }
            return true;
        });
    }
});
